import { render, staticRenderFns } from "./CheckboxesColors.vue?vue&type=template&id=31ceda02&"
import script from "./CheckboxesColors.vue?vue&type=script&lang=js&"
export * from "./CheckboxesColors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports